import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
import { PostbackItem } from "@/services/TablePage/postbacks";
import BaseListItem from "@/components-UI/list/BaseListItem.vue";
import ViewDateTime from "@/components/base/ViewDateTime.vue";
import { PostbackItemTypes } from "@/services/TablePage/postbacks";
import { getRemainingTime } from '@/utils/formatDates';
import { useCopyText } from "@/utils/copyText";
import BaseChip from "@/components-UI/BaseChip.vue";
import SvgClock from "@/assets/icons/clock2.svg";
import SvgCheck from "@/assets/icons/check.svg";
import SvgAttention from "@/assets/icons/attention-symbol.svg";
import SvgCopy from "@/assets/icons/copy2.svg";
import BaseTooltip from "@/components-UI/BaseTooltip.vue";
import { useWindowResize } from "@/utils/useWindowSize";

interface Props {
    item: PostbackItem;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PostbackListItems',
  props: {
    item: null
  },
  setup(__props: any) {

const props = __props as {
    item: PostbackItem;
}

const { width } = useWindowResize();


const Types = PostbackItemTypes;

const isDesktop = computed(() => width.value > 1264);

const isColumn = computed(() => {
    return props.item.label.slice(0, 3) !== 'Sub' &&
        !isDesktop.value &&
        props.item.valueKey !== 'transaction_id' &&
        (props.item.isCopyOnClick || props.item.isCodeStyle || props.item.isURLStyle);
});

const copyValue = () => {
    useCopyText(props.item.value, 'Скопировано');
};

const formattedJson = computed(() => {
    try {
        const jsonObject = typeof props.item.value === 'string'
            ? JSON.parse(props.item.value)
            : props.item.value;

        const jsonString = JSON.stringify(jsonObject, null, 4);

        return jsonString
            .replace(/\n/g, '<br>')
            .replace(/ /g, '&nbsp;');
    } catch (e) {
        return props.item.value
            .replace(/\n/g, '<br>')
            .replace(/ /g, '&nbsp;');
    }
});

return { __sfc: true,width, props, Types, isDesktop, isColumn, copyValue, formattedJson, BaseListItem, ViewDateTime, getRemainingTime, BaseChip, SvgClock, SvgCheck, SvgAttention, SvgCopy, BaseTooltip }
}

})